interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  accent?: boolean;
}

export default function SectionHeading({ eyebrow, title, desc, accent }: SectionHeadingProps) {
  return (
    <div className="mb-8 max-w-2xl">
      {eyebrow && (
        <p className="mb-2 flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-primary-600">
          <span className="inline-block h-2 w-2 rounded-full bg-accent-500"></span>
          {eyebrow}
        </p>
      )}
      <h2 className={`text-2xl font-extrabold tracking-tight text-foreground-950 md:text-[2rem] md:leading-tight ${accent ? "text-primary-600" : ""}`}>
        {title}
      </h2>
      {desc && <p className="mt-3 text-sm leading-7 text-foreground-600">{desc}</p>}
    </div>
  );
}